import React, { Fragment, useState, useEffect } from 'react';
import { Dialog, Transition } from "@headlessui/react";
import axios from 'axios';
import Dashboard from './Dashboard';
import { BiSort } from "react-icons/bi";
import { MdDelete, MdEdit } from "react-icons/md";
import { useNavigate } from 'react-router-dom';

const BarrelBlankAdmin = () => {
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pages, setPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoadMore, setIsLoadMore] = useState(false);

    useEffect(() => {
        fetchData(1);
    }, []);

    const fetchData = (page) => {
        setIsLoadMore(true);
        axios.get(`${process.env.REACT_APP_API_URL}barrelBlanket/list?page=${page}&limit=20`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("apEnergyAdminToken")}`
            }
        })
            .then((res) => {
                if (page == 1) {
                    setData(res.data.data.data);
                } else {
                    setData(item => [...item, ...res.data.data.data]);
                }
                setPages(Number(res.data.data.totalPages));
                setCurrentPage(Number(res.data.data.currentPage));
                setIsLoadMore(false);
                setLoading(false);
            }).catch((err) => {
                console.log(err);
                setIsLoadMore(false);
                setLoading(false);
            })
    }

    const [searchTerm, setSearchTerm] = useState("");
    const [searchResult, setSearchResult] = useState([]);

    const getSearchTerm = (e) => {
        searchData(e.target.value);
    };

    const searchData = (data) => {
        setSearchTerm(data);
        setLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL}barrelBlanket/search?query=${data}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("apEnergyAdminToken")}`
            }
        }).then((res) => {
            if (res && res.data && res.data.success) {
                setSearchResult(res.data.data);
                setLoading(false);
            }
        }).catch(err => {
            setLoading(false);
        })
    }

    const [filterDate, setFilterDate] = useState(false);
    const dateHandler = (e) => {
        if (filterDate !== true) {
            setSearchResult(data.reverse());
            setFilterDate(true);
        }
        else {
            setData(searchResult.reverse());
            setFilterDate(false);
        }
    }

    const deleteData = (e) => {
        axios.delete(`${process.env.REACT_APP_API_URL}barrelBlanket/${e}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("apEnergyAdminToken")}`
            }
        })
            .then((res) => {
                alert("Data Deleted Successfully");
                window.location.reload();
            })
            .catch((err) => {
                alert("Error while deleting Data");
            })
    }

    let [isOpen, setIsOpen] = useState(false);

    function closeModal() {
        setLoading(true);
        fetchData(1);
        setIdData({});
        setIsOpen(false);
    }

    function openModal(id) {
        getDataById(id);
        setIsOpen(true);
    }

    const [idData, setIdData] = useState({});
    const [username, setUsername] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [utility, setUtility] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [zipCode, setZipCode] = useState("");
    const [facilityOperatingHours, setFacilityOperatingHours] = useState("");
    const [ambientTemperature, setAmbientTemperature] = useState("");
    const [barrelEntries, setBarrelEntries] = useState([]);

    const getDataById = (id) => {
        axios.get(`${process.env.REACT_APP_API_URL}barrelBlanket/${id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("apEnergyAdminToken")}`
            }
        })
            .then((res) => {
                if (res && res.data && res.data.success) {
                    const data = res.data.data;
                    setIdData(data);
                    setUsername(data.username || "");
                    setCompanyName(data.companyName || "");
                    setUtility(data.utility || "");
                    setCity(data.city || "");
                    setState(data.state || "");
                    setZipCode(data.zipCode || "");
                    setFacilityOperatingHours(data.facilityOperatingHours || "");
                    setAmbientTemperature(data.ambientTemperature || "");
                    setBarrelEntries(data.barrelEntries || []);
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const updateData = (id) => {
        axios.put(`${process.env.REACT_APP_API_URL}barrelBlanket/${id}`, {
            username: username,
            companyName: companyName,
            utility: utility,
            city: city,
            state: state,
            zipCode: zipCode,
            facilityOperatingHours: facilityOperatingHours,
            ambientTemperature: ambientTemperature,
            barrelEntries: barrelEntries
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("apEnergyAdminToken")}`
            }
        }).then((res) => {
            console.log(res);
            alert("Data Updated Successfully");
            closeModal();
        }).catch((err) => {
            console.log(err);
            alert("Error updating data");
        })
    }

    return (
        <>
            <Dashboard>
                <div className='flex flex-col md:flex-row gap-4 justify-center items-center mt-2'>
                    <input
                        className='h-12 border-2 border-teal-600 rounded-lg text-center w-5/12'
                        placeholder='Search Here'
                        onChange={getSearchTerm}
                    />
                </div>
                <div className="mt-8 relative overflow-x-auto shadow-md sm:rounded-lg h-[80vh]">
                    <table className="w-full text-sm text-left text-gray-500">
                        <thead className="text-sm text-gray-700 bg-gray-50 sticky top-0 z-10">
                            <tr className="text-base text-center">
                                {/* <th scope="col" className="px-3 py-3">
                                    Edit
                                </th> */}
                                <th scope="col" className="px-3 py-3">
                                    <div className='flex items-center justify-center'>
                                        <span>Date</span><BiSort onClick={dateHandler} />
                                    </div>
                                </th>
                                <th scope="col" className="px-3 py-3">
                                    Username
                                </th>
                                <th scope="col" className="px-3 py-3">
                                    Company Name
                                </th>
                                <th scope="col" className="px-3 py-3">
                                    Utility
                                </th>
                                <th scope="col" className="px-3 py-3">
                                    City
                                </th>
                                <th scope="col" className="px-3 py-3">
                                    State
                                </th>
                                <th scope="col" className="px-3 py-3">
                                    Delete
                                </th>
                                <th scope="col" className="px-3 py-3">
                                    Details
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                loading ?
                                    <tr>
                                        <td colSpan="9" className="text-center py-4">
                                            <svg
                                                role="status"
                                                className="inline w-8 h-8 mr-2 text-gray-200 animate-spin fill-blue-600"
                                                viewBox="0 0 100 101"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="currentFill"
                                                />
                                            </svg>
                                        </td>
                                    </tr>
                                    :
                                    <>
                                        {
                                            searchTerm.length < 1 ?
                                                data.map((item, idx) => {
                                                    return (
                                                        <tr className="bg-white border-b text-center cursor-pointer text-[11px]" key={idx}>
                                                            {/* <td className="px-3 py-4">
                                                                <button
                                                                    type="button"
                                                                    onClick={() => { openModal(item._id) }}
                                                                    className="rounded-md text-base font-medium text-white hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
                                                                >
                                                                    <MdEdit color='blue' />
                                                                </button>
                                                            </td> */}
                                                            <th
                                                                scope="row"
                                                                className="px-3 py-4 font-medium text-gray-900 whitespace-nowrap"
                                                            >
                                                                {new Date(item.date).toLocaleString()}
                                                            </th>
                                                            <td className="px-3 py-4">{item.username}</td>
                                                            <td className="px-3 py-4">{item.companyName}</td>
                                                            <td className="px-3 py-4">{item.utility || 'N/A'}</td>
                                                            <td className="px-3 py-4">{item.city || 'N/A'}</td>
                                                            <td className="px-3 py-4">{item.state || 'N/A'}</td>
                                                            <td className="px-3 py-4">
                                                                <button
                                                                    type="button"
                                                                    className="rounded-md py-2 text-base font-medium text-white hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
                                                                    onClick={() => { if (window.confirm('Are you sure to delete this record?')) { deleteData(item._id) }; }}
                                                                >
                                                                    <MdDelete color='blue' />
                                                                </button>
                                                            </td>
                                                            <td className="px-3 py-4">
                                                                <p className='w-[80px] bg-teal-600 text-white p-[5px] rounded-lg mx-auto' onClick={() => { navigate(`/barrelBlankDetail/${item._id}`) }}>View Details</p>
                                                            </td>
                                                        </tr>
                                                    )
                                                })

                                                :

                                                searchResult.map((item, idx) => {
                                                    return (
                                                        <tr className="bg-white border-b text-center cursor-pointer text-[11px]" key={idx}>
                                                            {/* <td className="px-3 py-4">
                                                                <button
                                                                    type="button"
                                                                    onClick={() => { openModal(item._id) }}
                                                                    className="rounded-md text-base font-medium text-white hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
                                                                >
                                                                    <MdEdit color='blue' />
                                                                </button>
                                                            </td> */}
                                                            <th
                                                                scope="row"
                                                                className="px-3 py-4 font-medium text-gray-900 whitespace-nowrap"
                                                            >
                                                                {new Date(item.date).toLocaleString()}
                                                            </th>
                                                            <td className="px-3 py-4">{item.username}</td>
                                                            <td className="px-3 py-4">{item.companyName}</td>
                                                            <td className="px-3 py-4">{item.utility || 'N/A'}</td>
                                                            <td className="px-3 py-4">{item.city || 'N/A'}</td>
                                                            <td className="px-3 py-4">{item.state || 'N/A'}</td>
                                                            <td className="px-3 py-4">
                                                                <button
                                                                    type="button"
                                                                    className="rounded-md px-4 py-2 text-base font-medium text-white hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
                                                                    onClick={() => { if (window.confirm('Are you sure to delete this record?')) { deleteData(item._id) }; }}
                                                                >
                                                                    <MdDelete color='blue' />
                                                                </button>
                                                            </td>
                                                            <td className="px-3 py-4">
                                                                <p className='w-[80px] bg-teal-600 text-white p-[5px] rounded-lg mx-auto' onClick={() => { navigate(`/barrelBlankDetail/${item._id}`) }}>View Details</p>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                        }
                                    </>
                            }
                        </tbody>
                    </table>
                </div>

                <Transition appear show={isOpen} as={Fragment}>
                    <Dialog as="div" className="relative z-10" onClose={closeModal}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-black bg-opacity-25" />
                        </Transition.Child>

                        <div className="fixed inset-0 overflow-y-auto">
                            <div className="flex min-h-full items-center justify-center p-4 text-center">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 scale-95"
                                    enterTo="opacity-100 scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 scale-100"
                                    leaveTo="opacity-0 scale-95"
                                >
                                    <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all max-h-[90vh] overflow-y-auto">
                                        <Dialog.Title
                                            as="h3"
                                            className="text-lg font-medium leading-6 text-gray-900"
                                        >
                                            Update Barrel Blank Form
                                        </Dialog.Title>
                                        <div className="mt-2">
                                            <div class="grid gap-6 mb-6 lg:grid-cols-2">
                                                <div>
                                                    <label
                                                        for="Username"
                                                        class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                                    >
                                                        Username
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="Username"
                                                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                                                        placeholder="Username"
                                                        value={username}
                                                        onChange={(e) => { setUsername(e.target.value) }}
                                                    />
                                                </div>
                                                <div>
                                                    <label
                                                        for="Company Name"
                                                        class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                                    >
                                                        Company Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="Company Name"
                                                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                                                        placeholder="Company Name"
                                                        value={companyName}
                                                        onChange={(e) => { setCompanyName(e.target.value) }}
                                                    />
                                                </div>
                                                <div>
                                                    <label
                                                        for="Utility"
                                                        class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                                    >
                                                        Utility
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="Utility"
                                                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                                                        placeholder="Utility"
                                                        value={utility}
                                                        onChange={(e) => { setUtility(e.target.value) }}
                                                    />
                                                </div>
                                                <div>
                                                    <label
                                                        for="City"
                                                        class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                                    >
                                                        City
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="City"
                                                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                                                        placeholder="City"
                                                        value={city}
                                                        onChange={(e) => { setCity(e.target.value) }}
                                                    />
                                                </div>
                                                <div>
                                                    <label
                                                        for="State"
                                                        class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                                    >
                                                        State
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="State"
                                                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                                                        placeholder="State"
                                                        value={state}
                                                        onChange={(e) => { setState(e.target.value) }}
                                                    />
                                                </div>
                                                <div>
                                                    <label
                                                        for="Zip Code"
                                                        class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                                    >
                                                        Zip Code
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="Zip Code"
                                                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                                                        placeholder="Zip Code"
                                                        value={zipCode}
                                                        onChange={(e) => { setZipCode(e.target.value) }}
                                                    />
                                                </div>
                                                <div>
                                                    <label
                                                        for="Facility Operating Hours"
                                                        class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                                    >
                                                        Facility Operating Hours
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="Facility Operating Hours"
                                                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                                                        placeholder="Facility Operating Hours"
                                                        value={facilityOperatingHours}
                                                        onChange={(e) => { setFacilityOperatingHours(e.target.value) }}
                                                    />
                                                </div>
                                                <div>
                                                    <label
                                                        for="Ambient Temperature"
                                                        class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                                    >
                                                        Ambient Temperature
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="Ambient Temperature"
                                                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                                                        placeholder="Ambient Temperature"
                                                        value={ambientTemperature}
                                                        onChange={(e) => { setAmbientTemperature(e.target.value) }}
                                                    />
                                                </div>
                                            </div>
                                            <p className="text-sm text-gray-600 mb-2">
                                                Note: Barrel entries are complex nested data. Please use the detail view to see full barrel entry information.
                                            </p>
                                            <button
                                                type="submit"
                                                className="inline-flex justify-center rounded-md border border-transparent bg-teal-600 px-4 py-2 text-sm font-medium text-white"
                                                onClick={() => { updateData(idData._id) }}
                                            >
                                                Update
                                            </button>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </Dialog>
                </Transition>
                <div>
                    {
                        currentPage != pages &&
                        <>
                            {
                                !isLoadMore ?
                                    <button className='text-center w-[100%] bg-teal-600 text-white' onClick={() => { fetchData(currentPage + 1) }}>
                                        Load More
                                    </button>
                                    :
                                    <div className="text-center">
                                        <svg
                                            role="status"
                                            className="inline w-8 h-8 mr-2 text-gray-200 animate-spin fill-blue-600"
                                            viewBox="0 0 100 101"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                fill="currentFill"
                                            />
                                        </svg>
                                    </div>
                            }
                        </>
                    }
                </div>
            </Dashboard>
        </>
    )
}

export default BarrelBlankAdmin;

